import { useMemo } from "react";
import DISCOUNT_TYPES from "@constants/DiscountTypes";
import useDiscountsInfo from "@hooks/useDiscountsInfo";
import { useCurrentCurrencySymbol } from "@hooks/usePrices";

export default function useTieredDiscounts() {
  const discountInfo = useDiscountsInfo();
  const currencySymbol = useCurrentCurrencySymbol();

  const amountPercentInfo = discountInfo.find(({ type }) => type === DISCOUNT_TYPES.AMOUNT_PERCENT);
  const quantityPercentInfo = discountInfo.find(
    ({ type }) => type === DISCOUNT_TYPES.QUANTITY_PERCENT
  );

  const amountDiscounts = useMemo(
    () =>
      amountPercentInfo?.thresholdConditionAmount?.map((amount, index) => [
        parseFloat(amount),
        parseFloat(amountPercentInfo.thresholdResultPercentage[index]),
      ]) || null,
    [amountPercentInfo]
  );

  const quantityDiscounts = useMemo(
    () =>
      quantityPercentInfo?.thresholdConditionQuantity?.map((quantity, index) => [
        parseFloat(quantity),
        parseFloat(quantityPercentInfo.thresholdResultPercentage[index]),
      ]) || null,
    [quantityPercentInfo]
  );

  let type = null;
  let wording = "";
  if (amountDiscounts) {
    type = DISCOUNT_TYPES.AMOUNT_PERCENT;
    wording = `Spend ${currencySymbol}`;
  } else if (quantityDiscounts) {
    type = DISCOUNT_TYPES.QUANTITY_PERCENT;
    wording = "Buy ";
  }

  return {
    type,
    discounts: amountDiscounts || quantityDiscounts,
    wording,
  };
}
